// Module
var code = "<react-component name=\"ManageBookAndPay\"></react-component>\n";
// Exports
module.exports = code;